import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
// import RollingLogo from "../widget/rolling_logo";
import Speaker from "../layout/speaker";
// import ConfTimer from "../layout/conf_timer";
import './conf.css';

import Conf_1 from '../../image/conf/conf_1_university.png';
import Conf_2 from '../../image/conf/conf_2_y_innovators.png';
import Conf_3 from '../../image/conf/conf_2_engineer.png';
import Conf_4 from '../../image/conf/conf_4_it_prof.png';
import Conf_5 from '../../image/conf/conf_5_anyone.png';
import Why_1 from '../../image/conf/why-join_01.png';
import Why_2 from '../../image/conf/why-join_02.png';
import Why_3 from '../../image/conf/why-join_03.png';
import Why_4 from '../../image/conf/why-join_04.png';
import Why_5 from '../../image/conf/why-join_05.png';

class Conf extends Component {
    state = {
        // row: 5,
        // why1: true,
        // why2: false,
        // why3: false,
        // why4: false,
        // why5: false,
        check: "test",
    }

    // handleResize = () => {
    //     let width = window.innerWidth;
    //     if (width > 1100) {
    //         this.setState({ row: 5 });
    //     } else if (width > 930) {
    //         this.setState({ row: 4 });
    //     } else if (width > 768) {
    //         this.setState({ row: 3 });
    //     } else {
    //         this.setState({ row: 2 });
    //     }
    // }
    // updateWhy = (n) => {
    //     switch (n) {
    //         case 1:
    //             setTimeout(() => {
    //                 this.setState({ why1: true, why2: false, why3: false, why4: false, why5: false, });
    //             }, 0);
    //             break;
    //         case 2:
    //             setTimeout(() => {
    //                 this.setState({ why1: false, why2: true, why3: false, why4: false, why5: false, });
    //             }, 0);
    //             break;

    //         case 3:
    //             setTimeout(() => {
    //                 this.setState({ why1: false, why2: false, why3: true, why4: false, why5: false, });
    //             }, 0);
    //             break;

    //         case 4:
    //             setTimeout(() => {
    //                 this.setState({ why1: false, why2: false, why3: false, why4: true, why5: false, });
    //             }, 0);
    //             break;

    //         case 5:
    //             setTimeout(() => {
    //                 this.setState({ why1: false, why2: false, why3: false, why4: false, why5: true, });
    //             }, 0);
    //             break;
    //         default:
    //             break;


    //     }
    // }
    goToTheme = () => {
        var d = document.getElementById("theme");
        var topPos = d.offsetTop;
        var header = document.getElementById("header");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToProgram = () => {
        var d = document.getElementById("programme");
        var topPos = d.offsetTop;
        var header = document.getElementById("header");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToSpeakers = () => {
        var d = document.getElementById("speakers");
        var topPos = d.offsetTop;
        var header = document.getElementById("header");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToAudience = () => {
        var d = document.getElementById("audience");
        var topPos = d.offsetTop;
        var header = document.getElementById("header");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToWhy = () => {
        var d = document.getElementById("why");
        var topPos = d.offsetTop;
        var header = document.getElementById("header");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    goToSection = (n) => {
        // console.log(n);
        setTimeout(() => {
            this.setState({ check: n, }, () => {
                //callback
                switch (n) {
                    case "theme":
                        this.goToTheme();
                        break;
                    case "programme":
                        this.goToProgram();
                        break;
                    case "speakers":
                        this.goToSpeakers();
                        break;
                    case "audience":
                        this.goToAudience();
                        break;
                    case "why":
                        this.goToWhy();
                        break;
                    default:
                        break;
                }
            });
        }, 500);



    }
    updateVideo(type) {
        let videoSrc;
        if (type === 'session_1') {
            videoSrc = 'https://globalaichallenge.com/static/media/Speaker%201%20-%20Borong%20Lin.mp4';
        } else if (type === 'session_2') {
            videoSrc = 'https://globalaichallenge.com/static/media/Speaker%202%20-%20Peter%20Wong.mp4';
        } else if (type === 'session_3') {
            videoSrc = 'https://globalaichallenge.com/static/media/Speaker%203%20-%20Edmond%20Yu.mp4';
        } else if (type === 'session_4') {
            videoSrc = 'https://globalaichallenge.com/static/media/Speaker%204%20-%20Yin%20Shi.mp4';
        } else if (type === 'session_5') {
            videoSrc = 'https://globalaichallenge.com/static/media/Speaker%205%20-%20Brian%20Cheng.mp4';
        } 

        let video = document.getElementById('video');

        video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        // setInterval(() => {
        //     if (this.state.why1) {
        //         this.updateWhy(2);
        //     } else if (this.state.why2) {
        //         this.updateWhy(3);
        //     } else if (this.state.why3) {
        //         this.updateWhy(4);
        //     } else if (this.state.why4) {
        //         this.updateWhy(5);
        //     } else {
        //         this.updateWhy(1);
        //     }
        // }, 3000);
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.addEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });

        var sub = window.location.hash;
        sub = sub.slice(1);
        this.goToSection(sub);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.removeEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });
        this.setState = () => false;
    }

    render() {
        const { t } = this.props;
        // const { row } = this.state;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('conf-meta-title')}</title>
                    <meta name="title" content={t('conf-meta-title')} />
                    <meta name="description" content={t('conf-meta-description')} />
                    <meta name="keywords" content={t('conf-meta-keywords')} />
                </MetaTags>
                <div id="conference">
                    <div className="conf-banner pt-5">
                        <div className="container-fluid d-flex justify-content-center align-items-center">
                            <div>
                                <div className="conf-banner-headline-1 text-center my-4">{t('conf-banner-headline-1-1')}<br className="d-sm-none d-block" />{t('conf-banner-headline-1-2')}</div>
                                <div className="conf-banner-headline-2 text-center my-4">{t('conf-banner-headline-2')}</div>
                                <div className="conf-banner-headline-3 text-center my-4">{t('conf-banner-headline-3')}</div>
                                <div className="conf-banner-headline-4 text-center my-3">{t('conf-banner-headline-4')}</div>
                                {/* <div className="d-flex justify-content-center mt-5">
                                    <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight03 w-100 py-2 px-5">{t('REGISTER FOR CONFERENCE')}</button></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <RollingLogo /> */}
                    <div id="conf-intro">
                        <div className="container-fluid d-flex justify-content-center pt-5">
                            <div className="col-10 col-lg-8">
                                <p>{t('conf-intro-text-1')}<b>{t('conf-intro-text-2')}</b>{t('conf-intro-text-3')}</p>
                                <p>{t('conf-intro-text-4')}</p>
                                <p>{t('conf-intro-text-5')}</p>
                                <p>{t('conf-intro-text-6')}</p>
                            </div>
                        </div>
                        {/* <div className="d-flex justify-content-center mt-5">
                            <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight03 w-100 py-2 px-5">{t('REGISTER FOR CONFERENCE')}</button></a>
                        </div> */}
                    </div>
                    <div id="theme">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-lg-10 text-center pt-5">
                                <h2>{t('conf-theme-headline')}</h2>
                                <h5>{t('conf-theme-text')}</h5>
                            </div>
                        </div>
                    </div>
                    <div id="programme" className="py-5">
                        <div className="text-center">
                            <h2>{t('conf-rundown-headline')}</h2>
                            <h4 className="mt-3">{t('conf-rundown-date')}</h4>
                        </div>
                        <div className="conf-rundown-detail">
                            <div className="container-fluid d-flex justify-content-center my-5">
                                <div className="div-conf-rundown-detail-headerline col-12 col-lg-10">
                                    <div className="conf-rundown-detail-headerline text-center">{t('conf-rundown-detail-headerline-1')}</div>
                                </div>
                            </div>
                            <div className="container-fluid">
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time-xl text-end">{t('conf-rundown-detail-prorgram-time-1')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div>
                                            <div className="conf-rundown-detail-prorgram-info-title">{t('conf-rundown-detail-prorgram-title-1')}</div>
                                            {/* <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_0')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div> */}
                                        </div>
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-1')}</span>
                                            <span className="d-block">{t('conf-rundown-detail-prorgram-detail-1-2')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram-sm col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time-xl text-end">{t('conf-rundown-detail-prorgram-time-2')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-title">{t('conf-rundown-detail-prorgram-title-2')}</div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-2')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-2')}</span>
                                            <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_1')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-2')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-2')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-3')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-3')}</span>
                                            <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_2')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-3')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-3')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram-sm col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time-xl text-end">{t('conf-rundown-detail-prorgram-time-4')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-title">{t('conf-rundown-detail-prorgram-topic-4')}</div>
                                    </div>
                                </div>
                                {/* <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-4')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-4')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_4')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-4')}</span><br/>
                                            <span>{t('conf-rundown-detail-prorgram-detail-4')}</span>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-5')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-5')}</span>
                                            <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_3')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-5')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-5')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-6')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-6')}</span>
                                            <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_4')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-6')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-6')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-7')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-7')}</span>
                                            <div className="conf-rundown-detail-prorgram-replay d-flex align-self-center" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_5')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon ms-1"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-7')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-7')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-8')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-8')}</span>
                                                {/* <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_8')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div> */}
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-8')}</span><br />
                                            <span>{t('conf-rundown-detail-prorgram-detail-8')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="div-conf-rundown-detail-prorgram-sm col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time-xl text-end">{t('conf-rundown-detail-prorgram-time-9')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light-xl"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-title">{t('conf-rundown-detail-prorgram-topic-9')}</div>
                                    </div>
                                </div>
                                {/* <div className="div-conf-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="conf-rundown-detail-prorgram-time text-end">{t('conf-rundown-detail-prorgram-time-9')}</div>
                                    <div className="conf-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="conf-rundown-detail-program-break-light"></div>
                                            <div className="conf-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="conf-rundown-detail-program-info">
                                        <div className="conf-rundown-detail-prorgram-info-text">
                                            <div>
                                                <span className="d-block bold">{t('conf-rundown-detail-prorgram-topic-9')}</span>
                                                <div className={t('conf-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_9')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                            </div>
                                            <span>{t('conf-rundown-detail-prorgram-text-speaker')}</span>
                                            <span className="conf-rundown-detail-prorgram-text-xl bold">{t('conf-rundown-detail-prorgram-speaker-9')}</span><br/>
                                            <span>{t('conf-rundown-detail-prorgram-detail-9')}</span>
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="d-flex justify-content-center mt-5">
                                    <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight03 w-100 py-2 px-5">{t('REGISTER FOR CONFERENCE')}</button></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <Speaker row={2} />
                    <div id="audience">
                        <div className="container-fluid">
                            <h2 className="w-100 text-center py-5">{t('conf-target-headline-1')}</h2>

                            <div className="conf-target-info-1st-row d-flex justify-content-center">
                                <div className="conf-target-info px-1">
                                    <div className="d-flex justify-content-center"><img src={Conf_1} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className="conf-target-info-title text-center">{t('conf-target-info-title-1')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info px-1">
                                    <div className="d-flex justify-content-center"><img src={Conf_2} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className="conf-target-info-title text-center">{t('conf-target-info-title-2')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info px-1">
                                    <div className="d-flex justify-content-center"><img src={Conf_3} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className="conf-target-info-title text-center">{t('conf-target-info-title-3')}</div>
                                    </div>
                                </div>
                                <div className="conf-target-info px-1">
                                    <div className="d-flex justify-content-center"><img src={Conf_4} className="conf-target-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className="conf-target-info-title text-center">{t('conf-target-info-title-4')}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="conf-target-info-2nd-row mt-3">
                                <div className="conf-target-info-xl d-flex justify-content-center">
                                    <div className="d-flex justify-content-center"><img src={Conf_5} className="conf-target-info-img" alt="" /></div>
                                    <div className="conf-target-info-title d-flex align-items-center">{t('conf-target-info-title-5')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="why">
                        <div className="container-fluid">
                            <h2 className="w-100 text-center py-5">{t('conf-why-headline-1')}</h2>
                            <div id="conf-why-carousel" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active slide-1">
                                        <div className="d-flex justify-content-center"><img src={Why_1} className="conf-why-info-img" alt="" /></div>
                                        <div className="d-flex justify-content-center">
                                            <h5 className="w-100 text-center">{t('conf-why-info-title-1')}</h5>
                                        </div>
                                    </div>
                                    <div className="carousel-item slide-2">
                                        <div className="d-flex justify-content-center"><img src={Why_2} className="conf-why-info-img" alt="" /></div>
                                        <div className="d-flex justify-content-center">
                                            <h5 className="w-100 text-center">{t('conf-why-info-title-2')}</h5>
                                        </div>
                                    </div>
                                    <div className="carousel-item slide-3">
                                        <div className="d-flex justify-content-center"><img src={Why_3} className="conf-why-info-img" alt="" /></div>
                                        <div className="d-flex justify-content-center">
                                            <h5 className="w-100 text-center">{t('conf-why-info-title-3')}</h5>
                                        </div>
                                    </div>
                                    <div className="carousel-item slide-4">
                                        <div className="d-flex justify-content-center"><img src={Why_4} className="conf-why-info-img" alt="" /></div>
                                        <div className="d-flex justify-content-center">
                                            <h5 className="w-100 text-center">{t('conf-why-info-title-4')}</h5>
                                        </div>
                                    </div>
                                    <div className="carousel-item slide-5">
                                        <div className="d-flex justify-content-center"><img src={Why_5} className="conf-why-info-img" alt="" /></div>
                                        <div className="d-flex justify-content-center">
                                            <h5 className="w-100 text-center">{t('conf-why-info-title-5')}</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-indicators mt-5">
                                    <button type="button" data-bs-target="#conf-why-carousel" data-bs-slide-to="0" class="active"></button>
                                    <button type="button" data-bs-target="#conf-why-carousel" data-bs-slide-to="1"></button>
                                    <button type="button" data-bs-target="#conf-why-carousel" data-bs-slide-to="2"></button>
                                    <button type="button" data-bs-target="#conf-why-carousel" data-bs-slide-to="3"></button>
                                    <button type="button" data-bs-target="#conf-why-carousel" data-bs-slide-to="4"></button>
                                </div>

                            </div>
                            {/* <div className="d-flex justify-content-center">
                                <div className={why1 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_1} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-1')}</div>
                                    </div>
                                </div>
                                <div className={why2 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_2} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-2')}</div>
                                    </div>
                                </div>
                                <div className={why3 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_3} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-3')}</div>
                                    </div>
                                </div>
                                <div className={why4 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_4} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-4')}</div>
                                    </div>
                                </div>
                                <div className={why5 ? 'conf-why-info' : 'conf-why-info d-none'}>
                                    <div className="d-flex justify-content-center"><img src={Why_5} className="conf-why-info-img" alt="" /></div>
                                    <div className="d-flex justify-content-center">
                                        <div className={t('conf-why-info-title text-center TXT_bold')}>{t('conf-why-info-title-5')}</div>
                                    </div>
                                </div>

                            </div>
                            <div className="conf-why-line">
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <div className="conf-why-line-btn-1" onClick={() => this.updateWhy(1)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why1 ? 'conf-why-line-tri-1' : 'conf-why-line-tri-1 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-2" onClick={() => this.updateWhy(2)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why2 ? 'conf-why-line-tri-2' : 'conf-why-line-tri-2 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-3" onClick={() => this.updateWhy(3)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why3 ? 'conf-why-line-tri-3' : 'conf-why-line-tri-3 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-4" onClick={() => this.updateWhy(4)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why4 ? 'conf-why-line-tri-4' : 'conf-why-line-tri-4 d-none'}></div>
                                        </div>
                                    </div>
                                    <div className="conf-why-line-gap align-self-center"></div>
                                    <div>
                                        <div className="conf-why-line-btn-5" onClick={() => this.updateWhy(5)}></div>
                                        <div className="d-flex justify-content-center">
                                            <div className={why5 ? 'conf-why-line-tri-5' : 'conf-why-line-tri-5 d-none'}></div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="d-flex justify-content-center mt-5">
                                <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight03 w-100 py-2 px-5">{t('REGISTER FOR CONFERENCE')}</button></a>
                            </div> */}
                        </div>
                    </div>
                    <Footer />
                    {/* <ConfTimer date="10/12/2021 09:30 GMT+8" /> */}
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div className="ratio ratio-16x9">
                                    <video autoPlay playsInline controls src="" id="video">
                                        <source src="" type="video/mp4" />
                                    </video>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content bg-black">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>


                                <p>{t('alert-msg-1')}</p>
                                {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                            </div>

                        </div>
                    </div>
                </div>

            </div>



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Conf);



// WEBPACK FOOTER //
// ./src/components/pages/conf.js